import { render, staticRenderFns } from "./modalTransportOrderError.vue?vue&type=template&id=193fb43d&scoped=true"
import script from "./modalTransportOrderError.vue?vue&type=script&lang=js"
export * from "./modalTransportOrderError.vue?vue&type=script&lang=js"
import style0 from "./modalTransportOrderError.vue?vue&type=style&index=0&id=193fb43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fb43d",
  null
  
)

export default component.exports